import type { FC } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import DemoForm from '@segment/templates/Forms/DemoForm'

const copy = {
  heading: `Ready to see what Segment can do for you?`,
  button: `Talk to a Segment expert`,
}

const form = {
  id: `site-interactivetour-lp-demo`,
}

const GettingStarted: FC = () => (
  <Wrapper id="connect-with-sales">
    <StyledSection variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading variant="h2" tag="h3">
            {copy.heading}
          </CopyText.Heading>

          <FormWrapper>
            <DemoForm
              successMessageAppearance="twilioLight"
              isProgressive={true}
              buttonText={copy.button}
              customFormIdentifier={form.id}
            />
          </FormWrapper>
        </CopyTextBase>
      </Section.Copy>
    </StyledSection>
  </Wrapper>
)

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const FormWrapper = styled.div`
  max-width: 420px;
  margin: 60px auto 0 auto;
`

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
  }
`

export default GettingStarted
